import Tone from 'tone';

export const lfoTimeOptions = [
    {value: () => '128m', label:'128'}, 
    {value: () => '64m', label:'64'}, 
    {value: () => '32m', label:'32'}, 
    {value: () => '16m', label:'16'}, 
    {value: () => '8m', label:'8'}, 
    {value: () => '4m', label:'4'}, 
    {value: () => '2m', label:'2'}, 
    {value: () => '1m', label:'1'}, 
    {value: () => '2n', label:'1/2'}, 
    {value: () =>  '4n', label:'1/4'}, 
    {value: () =>  '4n.', label:'1/4.'}, 
    {value: () =>  '4t', label:'1/4t'}, 
    {value: () => '8n', label:'1/8'}, 
    {value: () =>  '8n.', label:'1/8.'}, 
    {value: () => '8t', label:'1/8t'}, 
    {value: () => '16n', label:'1/16'}, 
    {value: () => '16t', label:'1/16t'}, 
    {value: () => '32n', label:'1/32'}, 
];

export function getLFOTimeOption(value) {
    value = typeof value === 'function' ? value() : value;
    var options = lfoTimeOptions.filter((opt) =>
                                        {
                                            return opt.value() === value;
                                        });
    if (options.length == 0) {
        return lfoTimeOptions[0];
    }
    return options[0];
}

